import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { Helmet } from 'react-helmet'
import _get from 'lodash/get'
import withStyles from 'isomorphic-style-loader/lib/withStyles'
import _cloneDeep from 'lodash/cloneDeep'

import homeActions from '@actions/home'
import { getFavorite } from '@actions/reminders'
import { getBatchReminder } from '@actions/reminders'
import { getMolaHub } from '@actions/mola-hub'

import {
  getContentTypeName,
  getErrorCode,
  setBackToPageTitle,
  arrayToChunk,
  PageStyle,
  getSpecialRibbon,
  ImageSize,
} from '@source/lib/globalUtil'
import { isMatchLive, isMatchPassed } from '@source/lib/dateTimeUtil'
import history from '@source/history'

import LazyLoad from '@components/common/Lazyload'
import Carousel from '@components/carousel'
import PlaylistCard from '@components/playlist-card'
import VideoCard from '@components/video-card'
import HomeError from '@components/common/error'
import ListMenu from '@components/listMenu'
import MobileNavbar from '@components/MobileNavbar'
import ResumeVideoCard from '@components/resume-video-card'
import PlaylistWithStyle from '@components/playlist-with-style'
import AlertNotification from '@components/AlertNotification'

import InfiniteLoader from '@components/infinite-loader'
import { contentTypeList } from '@routes/feature/const'

import { resumeVideoContainer, BannerWrapper } from './style'

import styles from './home-featured.css'
import CarouselContainer from '@components/carousel-container'
import BannerCarousel from '@components/banner-carousel'
import Hub from '@components/hub'
import PlaylistHeader from './playlist-header'

const clone = require('rfdc')()
export class homeFeatured extends Component {
  state = {
    viewportWidth: this.props.isMobile ? 0 : 1200,
    carouselBannerHeight: 0,
    currentHomeData: null,
    currentIndex: 0,
    showLoader: true,
  }
  componentDidMount() {
    const {
      onHandlePlaylist,
      onHandleBanner,
      onHandleContinueWatching,
      onHandleRecommendationUser,
      getMolaHub,
      configParams,
      home,
      home: { playlists },
      user: { uid = '', sid = '' },
    } = this.props
    const isEnabled = _get(configParams, 'data.favorite_enabled', false)
    const isLogin = uid || sid
    if (playlists.meta.status !== 'success') {
      onHandleBanner()
      onHandlePlaylist()
      onHandleContinueWatching()
      onHandleRecommendationUser()
    } else {
      this.getAllData()
    }
    if (isEnabled && isLogin) {
      this.props.getFavorite('desc')
    }
    getMolaHub('home-new')
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  onVisible = () => {
    // console.log('onVisible called')
    this.loadMore()
  }

  loadMore = () => {
    const {
      home,
      home: { children, playlists },
      configParams,
    } = this.props

    const { currentHomeData } = this.state

    const rowPerLoad = _get(configParams, 'data.playlist_row_load', 5)
    const playlistMaxRowPerload = _get(configParams, 'data.playlist_max_row', 10)

    let cloneHomeData = clone(home)
    const startIndex = this.state.currentIndex * rowPerLoad
    const numRow = startIndex + rowPerLoad
    const isNeedInfiniteScroll = cloneHomeData && cloneHomeData.playlists.data.length > playlistMaxRowPerload

    if (isNeedInfiniteScroll) {
      cloneHomeData.playlists.data = currentHomeData
        ? [...currentHomeData.playlists.data, ...cloneHomeData.playlists.data.slice(startIndex, numRow)]
        : cloneHomeData.playlists.data.slice(startIndex, numRow)
      cloneHomeData.children.data = currentHomeData
        ? [...currentHomeData.children.data, ...cloneHomeData.children.data.slice(startIndex, numRow)]
        : cloneHomeData.children.data.slice(startIndex, numRow)
    }
    this.setState({
      currentHomeData: { ...cloneHomeData },
      currentIndex: this.state.currentIndex + 1,
      showLoader: cloneHomeData.playlists.data.length != playlists.data.length,
    })
  }

  getAllData = async () => {
    const {
      home,
      home: { children },
    } = this.props
    const childRequest =
      children.data &&
      children.data.map(async (playlist, index) => {
        if (
          playlist &&
          playlist.meta.status === 'success' &&
          getContentTypeName(playlist.meta.contentType) === 'live' &&
          playlist.data.length > 0
        ) {
          let ids = []
          playlist.data.map(r => {
            const tenMinutesBefore = r.startTime - 10 * 60
            if (getContentTypeName(r.contentType) === 'live' && !isMatchPassed(tenMinutesBefore)) {
              ids.push(r.id)
            }
          })
          if (ids.length > 0) {
            await this.props.getBatchReminder(playlist.meta.id, ids, 'home')
          }
        }
      })
    Promise.all(childRequest).then(() => {
      this.loadMore()
    })
  }

  componentDidUpdate(prevProps) {
    const {
      home,
      home: { children, playlists },
    } = this.props
    const {
      home: { children: prevChildren, playlists: prevPlaylists },
    } = prevProps

    const { currentHomeData, showLoader } = this.state
    if (
      playlists.meta.status === 'success' &&
      playlists.data.length > 0 &&
      currentHomeData &&
      currentHomeData.playlists.data.length == playlists.data.length &&
      showLoader
    ) {
      this.setState({
        showLoader: false,
      })
    }
    if (
      prevPlaylists.meta.status !== playlists.meta.status &&
      playlists.meta.status === 'success' &&
      playlists.data.length > 0
    ) {
      this.getAllData()
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  updateWindowDimensions = () => {
    this.setState({ viewportWidth: window.innerWidth })
  }

  handleOnClick = video => {
    const obj = {
      articles: () => setBackToPageTitle(`/articles/${video.id}`),
      banners: () => video.link,
      playlists: () => setBackToPageTitle(`/categories/${video.id}`),
      videos: () => {
        const videoTypesRedirectUri = {
          // linear: `/channels/${video.id}`,
          default: video.timePosition
            ? setBackToPageTitle(`/watch?v=${video.id}&time=${video.timePosition}&autoplay=1`)
            : setBackToPageTitle(`/watch?v=${video.id}`),
        }

        const contentTypeName = getContentTypeName(_get(video, 'contentType', 'default'))
        const linearRedirectId = _get(this.props.configParams, 'data.linear_redirect_id', [])
        let redirectUrl = videoTypesRedirectUri.default
        if (contentTypeName == 'linear') {
          if (linearRedirectId.includes(video.id)) {
            redirectUrl = videoTypesRedirectUri.default
          } else {
            redirectUrl = videoTypesRedirectUri[contentTypeName]
          }
        }
        return redirectUrl
      },
      playlist: () => setBackToPageTitle(`/categories/${video.id}`),
      video: () => setBackToPageTitle(`/watch?v=${video.id}`),
    }

    if (video) {
      /** only execute when a video object exist */
      if (video.type == 'banners') {
        window.location.href = obj[video.type]()
      } else {
        history.push(obj[video.type]())
      }
    } else {
      alert(`Mola does NOT recognized this link \n${JSON.stringify(video)}`)
    }
  }

  handleOnClickRecommendation = (video) => {
    const source = 'molatv', medium = 'recommendedforyou'
    if (video.is_playlist) {
      history.push(setBackToPageTitle(`/categories/${video.id}?utm_source=${source}&utm_medium=${medium}`))
    } else {
      history.push(setBackToPageTitle(`/watch?v=${video.id}&utm_source=${source}&utm_medium=${medium}`))
    }
  }

  render() {
    const {
      home,
      home: { playlists, videos, banners, children, resumeVideo, recommendationUser },
      watchList: { favorites },
      runtime: { isMobile },
      routes,
      configParams,
      molaHub,
    } = this.props,
      { viewportWidth, carouselBannerHeight, currentHomeData, showLoader } = this.state
    const isPlaylistsLoading = playlists.meta.status === 'loading',
      isPlaylistsError = playlists.meta.status === 'error',
      isPlaylistsSuccess = playlists.meta.status === 'success'

    const playlistError = playlists.meta.error || '',
      playlistErrorCode = getErrorCode(playlistError)

    const pageStyle = _get(playlists, 'meta.pageStyle', PageStyle.WITH_BANNER) || PageStyle.WITH_BANNER
    const hasBanner = true // pageStyle == PageStyle.WITH_BANNER

    const isResumeVideoAvailable = resumeVideo.meta.status === 'success' && resumeVideo.data.length > 0
    const isResumeVideoEnabled = configParams && configParams.data && configParams.data.resume_video_enabled

    const homeViewMoreMappingLinks = _get(configParams, 'quickAccess.home_featured_view_more_mappings', {})
    const resumeCarouselHeight = isMobile ? '11rem' : '20rem'
    const resumeSlideToShow = isMobile ? 2 : 4
    const recommendationUserToShow = isMobile ? 3 : 6
    const canShowHub = molaHub.meta.status === 'success',
      hubListsTop = _get(molaHub, 'data.channels.top', []),
      hubListsBot = _get(molaHub, 'data.channels.bottom', []),
      hubTitle = _get(molaHub, 'data.name', '')

    const isEnabled = _get(configParams, 'data.favorite_enabled', false)
    const recomUserEnabled = _get(configParams, 'data.recommendation_user_enabled', false)
    const {
      user: { uid = '', sid = '' },
    } = this.props
    const isLogin = uid || sid
    const favoriteMenuTitle = _get(configParams, 'naming.favorite.favorite_home_menu', 'My Favorites')
    const continueWatchTitle = _get(configParams, 'naming.continue_watch.continue_watching_title', 'Continue Watching')
    const recommendationUserTitle = _get(configParams, 'naming.recommendation_user.recommendation_user_title', 'Recommended for You')
    const btpMenuLabelFavorite = _get(configParams, 'naming.favorite.btp_menu_label', null)

    return (
      <>
        {isMobile && <ListMenu {...this.props} isMobile={isMobile} noHeader={this.props.runtime.noHeader} />}
        {isMobile && <MobileNavbar routes={routes} />}
        {isPlaylistsError && (
          <HomeError status={playlistErrorCode} message={playlistError || 'Mola TV playlist is not loaded'} />
        )}
        <AlertNotification withSideNavLayout isMobile={isMobile} />
        <div className={`${styles.content__wrapper} ${this.props.runtime.noHeader ? styles.hide : ''}`}>
          {isPlaylistsSuccess && (
            <>
              <Helmet>
                <title>{_get(playlists, 'meta.seo.title', '') || _get(playlists, 'meta.title', '')}</title>
              </Helmet>

              {hasBanner && (
                <BannerWrapper>
                  <BannerCarousel banners={banners} isMobile={isMobile}>
                    {banners.data.length > 0 &&
                      banners.data.map(obj => {
                        const ribbon = getSpecialRibbon(obj, ImageSize.LANDSCAPE)
                        return (
                          <PlaylistCard
                            transitionMode={'scroll'}
                            key={obj.id}
                            onClick={() => this.handleOnClick(obj)}
                            // src={`${obj.background.landscape}?w=${isMobile ? '450' : '800'}`}
                            src={`${obj.background.landscape}?w=450`}
                            srcset={`${obj.background.landscape}?w=450 450w,${obj.background.landscape}?w=640 640w, ${obj.background.landscape}?w=960 960w`}
                            sizes="(min-width: 768px) 30vw, 170px"
                            containerClassName={styles.banner__container}
                            isDetailHidden
                            bannerCard
                            onHoverBorder={false}
                            ribbon={ribbon}
                          />
                        )
                      })}
                  </BannerCarousel>
                </BannerWrapper>
              )}
              {canShowHub && hubListsTop.length > 0 && (
                <Hub isMobile={isMobile} hubTitle={hubTitle} list={hubListsTop} />
              )}
              <LazyLoad containerClassName={styles.container__card}>
                {isResumeVideoEnabled && isResumeVideoAvailable && (
                  <div className={resumeVideoContainer}>
                    <PlaylistHeader title={continueWatchTitle} showTitle={resumeVideo.data.length > 0} />

                    <CarouselContainer
                      isMobile={isMobile}
                      configParams={configParams}
                      handleOnClick={this.handleOnClick}
                      video={resumeVideo.data}
                      slideToShow={resumeSlideToShow}
                      initialHeight={resumeCarouselHeight}
                      withoutControls={resumeVideo.data.length < resumeSlideToShow}
                    >
                      {resumeVideo.data.map(obj => {
                        const ribbon = getSpecialRibbon(obj, ImageSize.LANDSCAPE)
                        return (
                          <ResumeVideoCard
                            {...obj}
                            key={obj.id}
                            alt={obj.title}
                            src={`${obj.background.landscape}?w=360`}
                            srcset={`${obj.background.landscape}?w=368 368w,${obj.background.landscape}?w=480 480w, ${obj.background.landscape}?w=640 640w, ${obj.background.landscape}?w=768 768w`}
                            sizes="(min-width: 768px) 20vw, 100px"
                            onClick={() => this.handleOnClick(obj)}
                            // containerClassName={videoCardContainer}
                            ribbon={ribbon}
                          />
                        )
                      })}
                    </CarouselContainer>
                  </div>
                )}
                {isLogin && isEnabled && favorites.meta.status === 'SUCCESS' && favorites.data.attributes.length > 0 && (
                  <div className={resumeVideoContainer}>
                    <PlaylistHeader
                      title={favoriteMenuTitle}
                      showTitle={favorites.data.attributes.length > 0}
                      showViewAll={true}
                      viewAllLink={`/accounts/profile?tab=watchList${isMobile ? `&btp=${btpMenuLabelFavorite}` : ''}`}
                      alignRight={true}
                    />
                    <CarouselContainer
                      isMobile={isMobile}
                      configParams={configParams}
                      handleOnClick={this.handleOnClick}
                      video={favorites.data.attributes}
                      slideToShow={resumeSlideToShow}
                      initialHeight={'0px'}
                      withoutControls={favorites.data.attributes.length < resumeSlideToShow}
                    >
                      {favorites.data.attributes.map(f => {
                        const ribbon = getSpecialRibbon(f.attributes, ImageSize.LANDSCAPE)
                        return (
                          <PlaylistCard
                            key={f.id}
                            containerClassName={styles.banner__container}
                            title={f.attributes.title}
                            description={f.attributes.description}
                            src={`${f.attributes.images.cover.landscape}?w=360`}
                            srcset={`${f.attributes.images.cover.landscape}?w=368 368w,${f.attributes.images.cover.landscape}?w=480 480w, ${f.attributes.images.cover.landscape}?w=640 640w, ${f.attributes.images.cover.landscape}?w=768 768w`}
                            sizes="(min-width: 768px) 20vw, 100px"
                            onClick={() => this.handleOnClick(f)}
                            ribbon={ribbon}
                          />
                        )
                      })}
                    </CarouselContainer>
                  </div>
                )}
                {isLogin && recomUserEnabled && recommendationUser.meta.status === 'success' && recommendationUser.data.length > 0 && (
                  <div className={resumeVideoContainer}>
                    <PlaylistHeader
                      title={recommendationUserTitle}
                      showTitle={recommendationUser.data.length > 0}
                      showViewAll={false}
                    />
                    <CarouselContainer
                      isMobile={isMobile}
                      configParams={configParams}
                      handleOnClick={this.handleOnClickRecommendation}
                      video={recommendationUser.data}
                      slideToShow={recommendationUserToShow}
                      initialHeight={'0px'}
                      withoutControls={recommendationUser.length < resumeSlideToShow}
                    >
                      {recommendationUser.data.map(recomUser => {
                        const ribbon = getSpecialRibbon(recomUser, ImageSize.PORTRAIT23)
                        return (
                          <VideoCard
                            key={recomUser.id}
                            // title={recomUser.title}
                            src={`${recomUser.images.cover.portrait}?w=180&h=270`}
                            srcset={`${recomUser.images.cover.portrait}?w=180&h=270 180w, ${recomUser.images.cover.portrait}?w=400&h=600 400w, ${recomUser.images.cover.portrait}?w=640&h=960 640w, ${recomUser.images.cover.portrait}?w=720&h=1080 720w`}
                            sizes='(min-width: 1024px) 15vw, 100px'
                            isRatio23={true}
                            onClick={() => this.handleOnClickRecommendation(recomUser)}
                            ribbon={ribbon}
                          />
                        )
                      })}
                    </CarouselContainer>
                  </div>
                )}
                {currentHomeData && currentHomeData.playlists.data.length > 0 && (
                  <>
                    <PlaylistWithStyle
                      playlist={currentHomeData}
                      isMobile={isMobile}
                      configParams={configParams}
                    // handleOnClick={this.handleOnClick}
                    />
                    {showLoader && <InfiniteLoader className={styles.infinite_loader} onVisible={this.onVisible} />}
                  </>
                )}
              </LazyLoad>
              {canShowHub && hubListsBot.length > 0 && (
                <Hub isMobile={isMobile} hubTitle={hubTitle} list={hubListsBot} position={'bottom'} />
              )}
            </>
          )}
        </div>
      </>
    )
  }
}

const mapStateToProps = state => {
  return {
    ...state,
  }
}

const mapDispatchToProps = dispatch => ({
  onHandlePlaylist: () => dispatch(homeActions.getHomePlaylist()),
  onHandleBanner: () => dispatch(homeActions.getHomeBanner()),
  onUpdatePlaylist: id => dispatch(homeActions.updateActivePlaylist(id)),
  onHandleContinueWatching: () => dispatch(homeActions.getContinueWatching()),
  onHandleRecommendationUser: () => dispatch(homeActions.getRecommendationUser()),
  getBatchReminder: (playlistId, ids, page) => dispatch(getBatchReminder(playlistId, ids, page)),
  getFavorite: order => dispatch(getFavorite(order)),
  getMolaHub: playlistId => dispatch(getMolaHub(playlistId)),
})

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(homeFeatured)
